import React from "react";
import {
  Box,
  Typography,
  Button,
  Paper,
  Avatar,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import OrederNotFound from "../assets/servererror.png";
import dalchini_logo from "../assets/Daalchinilogobrown.png";
import { Server } from "lucide-react";
const ServerErrorPage = () => {

  const GotoHome=()=>{
    window.location.href="/"
  }
    const GotoHelpSupport=()=>{
    window.location.href="/help&support"
  }
  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#e9e0d7",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          backgroundColor: "#f0d83c",
          height: 70,
          px: 2,
          display: "flex",
          alignItems: "center",
        }}
      >
       <Box
         src={dalchini_logo}         component="img"
         sx={{ height: 44, width: 120, mr: 2 }}  
            />
      </Box>

      {/* Card */}
      <Paper
        elevation={0}
        sx={{
          flex: 1,
          borderTopLeftRadius: 18,
          borderTopRightRadius: 18,
          mt: -1,
          p: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          backgroundColor: "#f7f7f7",
        }}
      >
        {/* Illustration */}
        <Box
          sx={{
           
            position: "relative",
            mt: 6,
            mb: 4,
          }}
        >
          <img
            src={OrederNotFound}
            alt="Order Not Found"
            width={160}
            height={183}
          />

        </Box>

        {/* Text */}
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            color: "#374151",
            mb: 1,
            fontSize: 20,
          }}
        >
         Something Went Wrong!
        </Typography>

        <Typography
          align="center"
          sx={{
            color: "#6b7280",
            fontSize: 14,
            maxWidth: 260,
            lineHeight: 1.6,
          }}
        >
      We Are Having Trouble Processing Your Request Due To A Server Error
        </Typography>

        <Typography
          onClick={() => window.location.reload()}
          sx={{
            mt: 4,
            color: "#6b7280",
            fontSize: 15,
            textDecoration: "underline",
            cursor: "pointer",
          }}
        >
          Please Try Again
        </Typography>





                <Paper
          elevation={2}
          sx={{
            mt: 3,
            width: "100%",
            maxWidth: 320,
            p: 1.5,
            borderRadius: 2,
            display: "flex",
            alignItems: "center",
            gap: 1,
            backgroundColor: "#f5efe9",
            boxShadow: "0px 4px 12px rgba(0,0,0,0.08)",
          }}
        >
          <ErrorOutlineIcon
            sx={{
              color: "#666",
              fontSize: 18,
              flexShrink: 0,
            }}
          />
          <Typography
            sx={{
              fontSize: 12,
              color: "#555",
              lineHeight: 1.4,
            }}
          >
            Please bear with us while we resolve this issue.
          </Typography>
        </Paper>
        {/* Bottom Buttons */}
        <Box
          sx={{
            mt: "auto",
            width: "100%",
            display: "flex",
            gap: 2,
            mb: 2,
          }}
        >
          <Button
            fullWidth
            variant="outlined"
            startIcon={<HomeIcon />}
            sx={{
              borderRadius: 2,
              py: 1.2,
              borderColor: "#00b67a",
              color: "#00b67a",
              fontWeight: 600,
              textTransform: "none",
            }}
            onClick={()=>{GotoHome()}}
          >
            Home
          </Button>

          <Button
            fullWidth
            variant="contained"
            startIcon={<HeadsetMicIcon />}
            sx={{
              borderRadius: 2,
              py: 1.2,
              backgroundColor: "#b7e5d3",
              color: "#00a86b",
              fontWeight: 600,
              textTransform: "none",
              boxShadow: "none",
              "&:hover": {
                backgroundColor: "#a8dcc8",
                boxShadow: "none",
              },
            }}
            onClick={()=>{GotoHelpSupport()}}
          >
            Help
          </Button>
        </Box>

        <Typography
          sx={{
            fontSize: 13,
            color: "#7c7c7c",
          }}
        >
          If The Issue Persists, Click Help.
        </Typography>
      </Paper>
    </Box>
  );
};

export default ServerErrorPage;